"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("../types/type");
var value_1 = require("../evaluator/value");
var util_1 = require("../evaluator/util");
var utils_1 = require("./utils");
function registerStringFunctions(context) {
    var stringOrNumber = { type: "union", options: [type_1.StringType, type_1.NumberType] };
    context.registerFunction('concatenate', [
        {
            invokeWithASTParameters: false,
            signature: {
                type: "variadic",
                parameters: [{ type: "union", options: [type_1.StringType, type_1.NumberType, type_1.BooleanType] }],
                variadicParameters: type_1.AnyType,
                returns: type_1.StringType,
            },
            invoke: function (params) {
                var flattened = [];
                for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
                    var p = params_1[_i];
                    if (util_1.isArrayValue(p)) {
                        flattened.push.apply(flattened, p.elements);
                    }
                    else {
                        flattened.push(p);
                    }
                }
                return value_1.Value.string(flattened.map(util_1.valueToString).join(""));
            },
        },
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [{ type: "array", elements: type_1.AnyType }],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var array = _a[0];
                return value_1.Value.string(array.elements.map(util_1.valueToString).join(""));
            },
        },
    ]);
    context.registerFunction('exact', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType, type_1.AnyType],
            returns: type_1.BooleanType,
        },
        invoke: function (_a) {
            var a = _a[0], b = _a[1];
            return value_1.Value.boolean(util_1.valueToString(a) === util_1.valueToString(b));
        },
    });
    context.registerFunction('left', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType, type_1.NumberType],
            returns: type_1.StringType
        },
        invoke: function (_a) {
            var input = _a[0], countValue = _a[1];
            var str = util_1.valueToString(input);
            var count = Math.min(str.length, countValue.value);
            return value_1.Value.string(str.substring(0, count));
        },
    });
    context.registerFunction('len', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var input = _a[0];
            return value_1.Value.number(util_1.valueToString(input).length);
        },
    });
    context.registerFunction('lower', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var input = _a[0];
            return value_1.Value.string(util_1.valueToString(input).toLowerCase());
        },
    });
    context.registerFunction('right', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType, type_1.NumberType],
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var input = _a[0], countValue = _a[1];
            var str = util_1.valueToString(input);
            var count = Math.min(str.length, countValue.value);
            return value_1.Value.string(str.substring(str.length - count, str.length));
        },
    });
    context.registerFunction('trim', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var input = _a[0];
            return value_1.Value.string(util_1.valueToString(input).trim());
        },
    });
    context.registerFunction('upper', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var input = _a[0];
            return value_1.Value.string(util_1.valueToString(input).toUpperCase());
        },
    });
    context.registerFunction('char', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [{ type: "union", options: [type_1.StringType, type_1.NumberType] }],
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var code = _a[0];
            return value_1.Value.string(String.fromCharCode(util_1.coerceNumber(code)));
        },
    });
    context.registerFunction('substitute', [
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [type_1.StringType, type_1.StringType, type_1.StringType],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var textValue = _a[0], searchValue = _a[1], replaceValue = _a[2];
                var text = util_1.valueToString(textValue), search = util_1.valueToString(searchValue), replace = util_1.valueToString(replaceValue);
                // use split/replace because String.prototype.replaceAll is too new :/
                return value_1.Value.string(text.split(search).join(replace));
            },
        },
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [type_1.StringType, type_1.StringType, type_1.StringType, type_1.NumberType],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var textValue = _a[0], searchValue = _a[1], replaceValue = _a[2], nthValue = _a[3];
                var text = util_1.valueToString(textValue), search = util_1.valueToString(searchValue), replace = util_1.valueToString(replaceValue);
                // nth param is 1-indexed, convert to 0-indexed
                var nth = util_1.coerceNumber(nthValue) - 1;
                var current = 0, index = -1;
                do {
                    index = text.indexOf(search, current === 0 ? 0 : index + search.length);
                    current++;
                } while (current <= nth && index >= 0);
                if (index >= 0) {
                    var before_1 = text.substring(0, index);
                    var after_1 = text.substring(index + search.length, text.length);
                    return value_1.Value.string(before_1 + replace + after_1);
                }
                else {
                    return textValue;
                }
            },
        },
    ]);
    context.registerFunction('regexmatch', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.StringType, type_1.StringType],
            returns: type_1.BooleanType,
        },
        invoke: function (_a) {
            var string = _a[0], regexStr = _a[1];
            var regex = new RegExp(util_1.valueToString(regexStr));
            return value_1.Value.boolean(regex.test(util_1.valueToString(string)));
        },
    });
    context.registerFunction('join', {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.StringType],
            variadicParameters: {
                type: 'union',
                options: [type_1.StringType, type_1.NumberType, type_1.BooleanType, type_1.AnyArrayType],
            },
            returns: type_1.StringType,
        },
        invoke: function (_a) {
            var delimiter = _a[0], params = _a.slice(1);
            var flattened = [];
            for (var _i = 0, params_2 = params; _i < params_2.length; _i++) {
                var p = params_2[_i];
                if (util_1.isArrayValue(p)) {
                    flattened.push.apply(flattened, p.elements);
                }
                else {
                    flattened.push(p);
                }
            }
            return value_1.Value.string(flattened.map(util_1.valueToString).join(util_1.valueToString(delimiter)));
        },
    });
    context.registerFunction('dollar', [
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var value = _a[0];
                return utils_1.toCurrency(value, value_1.Value.number(2));
            },
        },
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber, stringOrNumber],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var value = _a[0], decimals = _a[1];
                return utils_1.toCurrency(value, decimals);
            },
        },
    ]);
}
exports.default = registerStringFunctions;
//# sourceMappingURL=strings.js.map